import React, { useEffect, useState } from 'react';
import Page from '../page';
import { Card, Button, BUTTON_VARIANTS, Link } from 'cdk-radial';
import { useDispatch, useSelector } from 'react-redux';
import './Menu.scss';
import { environmentURLs } from '../common/CaptureEnvironment';
import { MSA_CONSENT_STATUS, PAGE_TITLE } from '../../constants/constants'
import { AMPLITUDE_EVENTS } from '../../constants/amplitudeConstants';
import { sendAmplitudeData, getOrgAmplitudeProperties } from '../../utils/amplitude';
import { getCartDetails } from '../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { TermsViewer } from '../TermsViewer/TermsViewer';

const ROUTES = {
  API_DIRECTORY: 'api-directory',
  MARKETPLACE: 'marketplace',
  MY_APIS: 'my-apis',
  MY_APPS: 'management'
};

const buttonClickHandler = (redirectUrl, loginDetails) => {
  const orgAmplitudeProperties = getOrgAmplitudeProperties(loginDetails);
  
  if (redirectUrl === ROUTES.MARKETPLACE) {
    sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_DASHBOARD_SHOP_MARKETPLACE, orgAmplitudeProperties);
    window.open(
      environmentURLs.REACT_APP_MARKETPLACE_URL,
      '_blank',
      'noopener'
    );
  } else {
    if (redirectUrl === ROUTES.API_DIRECTORY) {
      localStorage.setItem(
        'componentToRender',
        JSON.stringify({ page: 'apiDirHome', props: {} })
      );
      sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_DASHBOARD_SHOP_APIS, orgAmplitudeProperties);
    }
    else if (redirectUrl === ROUTES.MY_APPS) {
      sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_DASHBOARD_MY_APPS, orgAmplitudeProperties);
    }
    else if (redirectUrl === ROUTES.MY_APIS) {
      sendAmplitudeData(AMPLITUDE_EVENTS.DEALER_DASHBOARD_MY_APIS, orgAmplitudeProperties);
    }
    let url = window.location.href.split('/home')[0];
    localStorage.setItem('dplocationWithoutApp', `${url}/${redirectUrl}`);
    window.location.assign(localStorage.getItem('dplocationWithoutApp'));
  }
};

const MainMenu = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const {
    decodedToken: { firstName } = {},
    fortellisEnterpriseEntityId,
    authenticationToken: token,
    isDealerPurchaseDisabled,
    hasDAABAccess
  } = state?.loginDetailsSlice;
  const {
    daabConsentDetails,
  } = state?.apiDirectorySlice;
  
  const isMsaConsented =
    daabConsentDetails?.consentStatus === MSA_CONSENT_STATUS.CONSENTED;

  const addendumClickHandler = () => {
    setIsTermsOpen(true);
  };

  const [isTermsOpen, setIsTermsOpen] = useState(false);

  useEffect(() => {
    if (fortellisEnterpriseEntityId) {
      dispatch(
        getCartDetails({ entityId: fortellisEnterpriseEntityId, token })
      );
    }
  }, [fortellisEnterpriseEntityId]);

  return (
    <Page pageHeader={PAGE_TITLE.DASHBOARD}>
      {!hasDAABAccess && <TermsViewer isTermsOpen={isTermsOpen} setIsTermsOpen={setIsTermsOpen} />}
      <div className="main-menu-container">
        <div className="main-menu-sub-container">
          <div className="menu-header">
            <div data-testid="header-text-id" className="header-text">
              {`Hi${firstName ? `, ${firstName}` : ''}`}
            </div>
          </div>
          <div className="menu-helper-text">Explore APIs and Apps</div>
          <div className="card-container">
            <Card className="card">
              <div className="card-body">
                <div className="card-body-subsection">
                  <span className="card-heading">API Directory</span>
                  <span className="card-text">
                    Start exploring the APIs that solve your service
                    requirements.
                  </span>
                </div>
                <Button
                  data-testid="api-directory-btn"
                  className="card-btn"
                  onClick={() => buttonClickHandler(ROUTES.API_DIRECTORY, state?.loginDetailsSlice)}
                  text="Shop API Directory"
                  variant={BUTTON_VARIANTS.PRIMARY}
                />
              </div>
            </Card>
            <Card className="card">
              <div className="card-body">
                <div className="card-body-subsection">
                  <span className="card-heading">App Marketplace</span>
                  <span className="card-text">
                    Start subscribing to apps on Fortellis Marketplace.
                  </span>
                </div>
                <Button
                  data-testid="app-marketplace-btn"
                  className="card-btn"
                  onClick={() => buttonClickHandler(ROUTES.MARKETPLACE, state?.loginDetailsSlice)}
                  text="Shop Marketplace"
                  variant={BUTTON_VARIANTS.PRIMARY}
                />
              </div>
            </Card>
          </div>
          <div className="menu-helper-text">Manage My APIs and Apps</div>
          <div className="card-container">
            <Card className="card">
              <div className="card-body">
                <div className="card-body-subsection">
                  <span className="card-heading">My APIs</span>
                  <span className="card-text">
                    Manage the APIs that are powering your dealership locations.
                  </span>
                </div>
                <Button
                  data-testid="my-apis-btn"
                  className="card-btn"
                  onClick={() => buttonClickHandler(ROUTES.MY_APIS, state?.loginDetailsSlice)}
                  text="Go to My APIs"
                  variant={BUTTON_VARIANTS.PRIMARY}
                />
              </div>
            </Card>
            <Card className="card">
              <div className="card-body">
                <div className="card-body-subsection">
                  <span className="card-heading">My Apps</span>
                  <span className="card-text">
                    Manage the Apps that help run your dealership.
                  </span>
                </div>
                <Button
                  data-testid="app-mgmt-btn"
                  className="card-btn"
                  onClick={() => buttonClickHandler(ROUTES.MY_APPS, state?.loginDetailsSlice)}
                  text="Go to My Apps"
                  variant={BUTTON_VARIANTS.PRIMARY}
                />
              </div>
            </Card>
            {isMsaConsented && !hasDAABAccess &&
            <div>
              <div className="addendum-heading">Addendum and Contracts</div>
              <div></div>
              <div className="addendum-link-div">
                <Link
                  onClick={() => addendumClickHandler()}
                  href="#"
                  text="Review the details for the API Purchase Compliance Addendum"
                />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </Page>
  );
};

export default MainMenu;
